import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import MenuDropDown from './MenuDropDown';

const Navbar = () => {


  return (
    <>
    <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top" style={{paddingTop:"0px",paddingBottom:"0px"}}>

      <Link to="/" style={{paddingTop:"0px",paddingBottom:"0px"}} className="navbar-brand" ><img src="assets/Logo Menubar.png" alt="Company Logo" width="200px" /></Link>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ml-auto">
          <MenuDropDown/>
          
          
          
          <li className="nav-item mr-3">
            <Link to="/About" className="nav-link" >About </Link>
          </li>
          
          <li  className="nav-item contact-us mr-3">
            <Link style={{color:"white",fontSize:"14px"}} to="/contact-us">CONTACT US</Link>
          </li>

        </ul>
      </div>
    </nav>
    </>
    
  )
}

export default Navbar;